
import {
    GET_LEAD_REFUND_REASONS,
    GET_LEAD_REFUND_REASONS_SUCCESS,
    GET_LEAD_REFUND_REASONS_ERROR,
} from "./actionTypes"
export const getLeadRefundReasons = payload => {
    return {
        type: GET_LEAD_REFUND_REASONS,
        payload: payload,
    }
}

export const getLeadRefundReasonsSuccess = leadRefundReasons => {
    return {
        type: GET_LEAD_REFUND_REASONS_SUCCESS,
        payload: leadRefundReasons,
    }
}

export const getLeadRefundReasonsError = error => {
    return {
        type: GET_LEAD_REFUND_REASONS_ERROR,
        payload: error,
    }
}

